import * as React from 'react'
import { O } from '@packages/prelude'
import * as domain from '@packages/domain'

export const ApiContext = React.createContext<O.Option<domain.Http.Deps>>(O.none)

export const ApiProvider: React.FC<React.PropsWithChildren<{ deps: domain.Http.Deps }>> = ({ deps, children }) => (
  <ApiContext.Provider value={O.some(deps)}>{children}</ApiContext.Provider>
)
